export function formatTimecode(ms: number): string {
  const totalFrames = Math.floor(ms / 40);
  const ff = totalFrames % 25;
  const totalSeconds = Math.floor(totalFrames / 25);
  const ss = totalSeconds % 60;
  const mm = Math.floor(totalSeconds / 60) % 60;
  const hh = Math.floor(totalSeconds / 3600);
  return [hh, mm, ss, ff].map((n) => String(n).padStart(2, '0')).join(':');
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} o`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} Ko`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`;
}

export function pad2(n: number): string {
  return String(n).padStart(2, '0');
}
